import { Component, ChangeDetectionStrategy } from '@angular/core'
import { BaseOnboardingCategoryDirective } from '../base-onboarding-category/base-onboarding-category.directive'

@Component({
  selector: 'lib-actions-with-candidates',
  templateUrl: './actions-with-candidates.component.html',
  styleUrls: ['../assets/styles.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsWithCandidatesComponent extends BaseOnboardingCategoryDirective {}
